import React, { FC, useContext, useEffect } from 'react';
import styles from '../../Games/components/ShowPartners.module.scss';
import { useStore } from '../../../../common';
import { AuthContext } from '../../../../logic';
import { Button } from 'esa-ui-library';
import { PERMISSIONS } from '../../../constants';

interface ShowGamesProps {
	onPrefsClick: (partner: { id: number; name: string; partner: string }) => void;
	onSettingsClick: (partner: { id: number; name: string; partner: string; gameId: number }) => void;
}

const ShowGames: FC<ShowGamesProps> = ({ onPrefsClick, onSettingsClick }): JSX.Element => {
	const [state, dispatch] = useStore();
	const { selectedGamePartner, partnerGames, partnerGamesLoading } = state;
	const { token, user } = useContext(AuthContext);

	const getGames = async () => {
		if (selectedGamePartner) {
			dispatch('PARTNER_GAMES_LOADING', true);
			await dispatch('FETCH_PARTNER_GAMES', {
				token,
				partnerId: selectedGamePartner.skinid,
			});
		}
	};

	useEffect(() => {
		getGames();
	}, [selectedGamePartner]);

	const handleDelete = async (gameId: number) => {
		if (!selectedGamePartner) return;
		if (!window.confirm('Are you sure you want to remove this game?')) return;

		await dispatch('REMOVE_GAME', {
			token,
			gameId,
			partnerId: selectedGamePartner.skinid,
		});

		await getGames();
	};

	return (
		<section className={styles.ShowPartners}>
			<div className={styles.ShowProviders}>
				<h2>Assigned Games</h2>
				<div className={styles.TableScroll}>
					<table>
						<thead>
							<tr>
								<th>Internal Game ID</th>
								<th>Name</th>
								<th>Provider</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{!partnerGamesLoading &&
								Array.isArray(partnerGames) &&
								partnerGames.map((game: any) => (
									<tr key={game.game_id}>
										<td>{game.internal_game_id}</td>
										<td>{game.game_name}</td>
										<td>{game.game_provider_name}</td>
										<td>
											<div className={styles.ActionButtons}>
												{(user?.permissions?.isSuperAdmin || user?.permissions[PERMISSIONS.canGetSkinPrefs]) && (
													<Button
														small
														className={styles.PrefsButton}
														onClick={() => {
															if (!selectedGamePartner) return;
															onPrefsClick({
																id: selectedGamePartner.skinid,
																name: selectedGamePartner.partner_name,
																partner: selectedGamePartner.partnerid,
															});
														}}
													>
														Prefs
													</Button>
												)}
												<Button
													small
													className={styles.SettingsButton}
													onClick={() => {
														if (!selectedGamePartner) return;
														onSettingsClick({
															id: selectedGamePartner.skinid,
															name: selectedGamePartner.partner_name,
															partner: selectedGamePartner.partnerid,
															gameId: game.internal_game_id,
														});
													}}
												>
													Game Settings
												</Button>
												<Button
													small
													danger
													className={styles.DeleteButton}
													onClick={() => handleDelete(game.internal_game_id)}
												>
													Delete
												</Button>
											</div>
										</td>
									</tr>
								))}
							{partnerGamesLoading && (
								<tr>
									<td colSpan={4}>Loading...</td>
								</tr>
							)}
							{!partnerGamesLoading && (!partnerGames || partnerGames.length === 0) && (
								<tr>
									<td colSpan={4}>No games assigned</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
};

export { ShowGames };
